<template>
	<el-dialog :close-on-click-modal="false"  :title="$t('layout.safeSet')" :visible.sync="googleModel" top="5vh" @close="hide" :width="isphone?'90%':'50%'">

		<!-- 表單内容 -->
		<el-form v-loading="load" :rules="info_rules" ref="form_info" :model="form_info" label-width="100px">
			 <el-tabs v-model="activeName" >
			    <el-tab-pane :label="$t('safe.google')" name="1">
					<div class="mb-3 text-center">
					<span class="mr-3">{{$t('safe.info1')}}</span>
					<el-button :loading="load" :disabled="load" size="small" @click="secretCheck"  type="success" >{{google_status==1?$t('safe.edit'):$t('safe.add')}}</el-button>
					
					<el-button v-if="google_status==1" :loading="load" :disabled="load" size="small" @click="closeSecret"  type="danger" >{{$t('safe.close')}}</el-button>
					
					
					</div>
					<div class="text-center">
						<span>{{$t('safe.secret')}} : </span>
						<span class="mr-3">
							{{google_status==1?info.google_secret:$t('safe.noset')}}  
							<span v-if="google_status==1" class="iconCopy" @click="copyText(info.google_secret)">
								<i class="iconfont icon-fuzhi"></i>
							</span>
						</span>
						
						 
						
					</div>
					
					<div class="text-center mt-3" v-if="google_status==1">
						<el-image 
						     style="width: 200px; height: 200px"
						     :src="info.google_qr"
						     ></el-image>
					</div>
				</el-tab-pane>
			    <el-tab-pane :label="$t('safe.ip')" name="2">
					
					
					
					<el-form-item :label="$t('safe.ip')" >
						<el-switch
						@change="editIpStatus"
						  v-model="ipStatus"
						  active-color="#13ce66"
						  inactive-color="#999999">
						</el-switch>
					</el-form-item>
					
					<el-form-item :label="$t('safe.iplist')" prop="ip">
						<div class="mb-2">
							<el-button class="ml-2 mt-2" :loading="load" :disabled="load" size="small" @click="editIp"   >{{!editStatus?$t('safe.edit'):$t('safe.sub')}}</el-button>
						</div>
						<el-input v-if="editStatus"   v-model="form_info.ip" type="textarea" :rows="8"  :placeholder="$t('safe.inpip')" clearable size="small" style="width: 85%;"></el-input>
						
						<div v-if="!editStatus">
							<div v-if="info.ip_arr">
								<pre style="line-height: 20px;">{{info.ip_arr}}</pre>
							</div>
							<div v-else>{{$t('safe.none')}}</div>
						</div>
					</el-form-item>
				</el-tab-pane>
			   
			  </el-tabs>
			
		
			
			
		
			
	
		</el-form>
	
	
		<div slot="footer" class="dialog-footer">
			<el-button @click="hide">{{$t('model.close')}}</el-button>
			<!-- <el-button type="primary" @click="submitinfo">{{$t('model.success')}}</el-button> -->
		</div>
	</el-dialog>
</template>

<script>
	import { commondecrypt } from '@/main';
	const user = JSON.parse(window.sessionStorage.getItem('user'))
	export default {
		inject: ['app'],
		props: {
			googleModel: {
				type: Boolean,
				default: false
			},
			isphone: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				ipStatus:false,
				info:{},
				ipdata:'',
				google_status:0,
				load:false,
				activeName:'1',
				editStatus:false,
				form_info:{
					ip:''
				},
				info_rules: {
					ip: [{
						required: true,
						message:  this.$t('safe.inpip2'),
						trigger: 'blur',
					}, ],
				
		
				},
			}
		},
		watch:{
			googleModel(newVal) {
				if(newVal){
					this.editStatus = false
					this.getInfo()
				}
			}
		},
		methods:{
			
		
			hide(){
				this.$emit('hide')
			},
			copyText(text) {
			  
				//console.log(111)
			  navigator.clipboard.writeText(text)
				.then(() => {
				  this.$message.success(this.$t('cdn.copy_ok'));
				})
				.catch(() => {
				  this.$message.error(this.$t('cdn.copy_fail'));
				});
			},
			
			
			editIp(){
				if(this.editStatus){
					this.$refs.form_info.validate(res => {
						if (res) {
							this.addSecret('ip',this.form_info);
							
						}
					})
				}else{
					this.editStatus = true
				}
			},
			getInfo(){
				this.load = true
				this.axios.post('/admin/user/userInfo', {type:'safe'}, {
					token: true
				}).then(res => {
					let all = res.data
					if (all.code == 1) {
						this.info = all.data.list
						this.form_info.ip = all.data.list.ip_arr
						this.ipStatus = all.data.list.ip_status==1?true:false
						if(all.data.list.google_secret){
							this.google_status = 1
							
						}
						console.log(all)
						// this.$message({
						// 	message:  all.msg,
						// 	type: 'success'
						// });
						// this.hide()
					}
					this.load = false
				}).catch(err => {
					this.load = false
				})
			},
			
			secretCheck(){
				if(this.google_status==1){
					this.$confirm(this.$t('safe.info'), this.$t('system.prompt'), {
						confirmButtonText: this.$t('safe.edit'),
						cancelButtonText: this.$t('system.cancel'),
						type: 'warning'
					}).then(() => {
						this.addSecret('google')
					})
				}else{
					this.addSecret('google')
				}
				
			},
			
			closeSecret(){
				this.load = true
				this.axios.post('/admin/user/closeGoogleSecret', {}, {
					token: true
				}).then(res => {
					let all = res.data
					if (all.code == 1) {
						this.info.google_secret = ''
						this.info.google_qr = ''
						this.google_status = 0
					}
					this.load = false
				}).catch(err => {
					this.load = false
				})
			},
			editIpStatus(){
				
				this.addSecret('ipstatus');
			},
			addSecret(type,data = ''){
				this.load = true
				this.axios.post('/admin/user/addGoogleSecret', {type:type,data:data}, {
					token: true
				}).then(res => {
					let all = res.data
					console.log(all)
					
					if (all.code == 1) {
						if(type=='google'){
							this.info.google_secret = all.data.list.google_secret
							this.info.google_qr = all.data.list.google_qr
							this.google_status = 1
						}
						if(type=='ipstatus'){
							this.ipStatus = all.data.list.status==1?true:false
						}
						if(type=='ip'){
							this.editStatus = false
							
							this.form_info.ip = all.data.list.ip_arr
							this.info.ip_arr = all.data.list.ip_arr
						}
						
					}
					this.load = false
				}).catch(err => {
					this.load = false
				})
			},
			
			
		}
	}
</script>

<style>
</style>
